var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vs-popup",
    {
      staticClass: "overlay posts-overlay-active-conciergerie",
      attrs: {
        title: _vm.$t(
          `dash.plan.active_conciergerie_now${
            _vm.activeConciergerie ? "_" + _vm.activeConciergerie.network : ""
          }`
        ),
        active: _vm.activeConciergerie,
      },
      on: {
        "update:active": function ($event) {
          _vm.activeConciergerie = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "form-connection-conciergerie" },
        [
          _c("p", { staticClass: "subtitle" }, [
            _vm._v(
              _vm._s(
                _vm.$t(`dash.bots.connection_subtitle_${_vm.page.network}`)
              )
            ),
          ]),
          _vm.linkedinConnected === "locked"
            ? _c("div", [
                _c("p", { staticClass: "connect-warning" }, [
                  _vm._v(
                    _vm._s(_vm.$t("dash.story.account.locked")) +
                      " " +
                      _vm._s(
                        new Date(_vm.page.story_config.lock).toLocaleString()
                      )
                  ),
                ]),
              ])
            : _vm.linkedinConnected === "connected"
            ? _c(
                "div",
                [
                  !_vm.noMatchId
                    ? _c("p", { staticClass: "connect-success" }, [
                        _vm._v(_vm._s(_vm.$t("dash.bots.connected_direct"))),
                      ])
                    : _c("div", [
                        _c("p", { staticClass: "connect-warning" }, [
                          _vm._v(_vm._s(_vm.$t("dash.bots.connected_match"))),
                        ]),
                      ]),
                  _vm.analysts && _vm.analysts.length
                    ? _c("p", { staticClass: "connect-warning" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("dash.bots.analysts") +
                              " " +
                              _vm.analysts.join(", ")
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm.usernamePageDiff
                    ? _c("p", { staticClass: "connect-warning" }, [
                        _vm._v(
                          _vm._s(
                            _vm
                              .$t("dash.bots.username_diff_insta")
                              .replace("d'utilisateur", _vm.usernamePageDiff) +
                              " " +
                              _vm.page.name
                          )
                        ),
                      ])
                    : _vm._e(),
                  !_vm.connectionReturn
                    ? _c(
                        "vs-button",
                        {
                          staticClass: "modify-btn-linkedin",
                          on: { click: () => (_vm.linkedinModify = true) },
                        },
                        [_vm._v("Modifier")]
                      )
                    : _vm._e(),
                  !_vm.connectionReturn
                    ? _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: _vm.$t("dash.pages.disconnect_conciergerie"),
                            position: "right",
                          },
                        },
                        [
                          _c(
                            "vs-button",
                            {
                              staticClass: "disconnect-conciergerie",
                              on: {
                                click: function ($event) {
                                  return _vm.disconnectConciergerie(_vm.page.id)
                                },
                              },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.header.nav.logout"))
                                ),
                              ]),
                            ]
                          ),
                          _c("span", [_vm._v(" ")]),
                        ],
                        1
                      )
                    : !_vm.noMatchId
                    ? _c(
                        "vs-button",
                        {
                          staticClass: "modify-btn-linkedin",
                          on: { click: _vm.closePopup },
                        },
                        [_vm._v("OK")]
                      )
                    : _vm._e(),
                  _vm.usernamePageDiff && !_vm.noMatchId
                    ? _c(
                        "vs-button",
                        {
                          staticClass: "disconnect-conciergerie",
                          on: {
                            click: function ($event) {
                              return _vm.disconnectConciergerie(_vm.page.id)
                            },
                          },
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$t("dash.header.nav.logout"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm.noMatchId
            ? _c(
                "div",
                [
                  _c("p", { staticClass: "connect-warning" }, [
                    _vm._v(_vm._s(_vm.$t("dash.bots.connected_match"))),
                  ]),
                  _c(
                    "vs-button",
                    {
                      staticClass: "modify-btn-linkedin",
                      on: { click: () => (_vm.noMatchId = false) },
                    },
                    [_vm._v("OK")]
                  ),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "conciergerie-instruction" },
                [
                  ["linkedin", "tiktok", "facebook", "twitter"].includes(
                    _vm.page.network
                  )
                    ? _c(
                        "h3",
                        { staticClass: "conciergerie-instruction-title" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.page.network === "tiktok"
                                ? _vm.$t("dash.bots.connection_method_tiktok")
                                : _vm.page.network === "facebook"
                                ? _vm.$t("dash.bots.connection_method_facebook")
                                : _vm.page.network === "twitter"
                                ? _vm.$t("dash.bots.connection_method_twitter")
                                : _vm.$t("dash.bots.connection_method_1")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  ["linkedin", "tiktok", "facebook", "twitter"].includes(
                    _vm.page.network
                  )
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "conciergerie-instruction-method method-1",
                        },
                        [
                          !_vm.extension
                            ? _c(
                                "vs-button",
                                { on: { click: _vm.useExtension } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        `dash.bots.connection_open_extension`
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          !_vm.extension
                            ? _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("dash.bots.extension_explication_1")
                                  )
                                ),
                              ])
                            : _vm._e(),
                          !_vm.extension
                            ? _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      `dash.bots.extension_explication_2_${_vm.page.network}`
                                    )
                                  ),
                                },
                              })
                            : _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      `dash.bots.extension_explication_3_${_vm.page.network}`
                                    )
                                  ),
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                  ["linkedin"].includes(_vm.page.network)
                    ? _c(
                        "h3",
                        { staticClass: "conciergerie-instruction-title" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("dash.bots.connection_method_2"))
                          ),
                        ]
                      )
                    : _vm._e(),
                  ["linkedin", "instagram"].includes(_vm.page.network)
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "conciergerie-instruction-method method-2",
                        },
                        [
                          _c("vs-input", {
                            attrs: {
                              label: _vm.$t(
                                `dash.bots.connection_email${
                                  _vm.page.network === "instagram"
                                    ? "_username"
                                    : ""
                                }`
                              ),
                              placeholder: _vm.$t(
                                `dash.bots.connection_email${
                                  _vm.page.network === "instagram"
                                    ? "_username"
                                    : ""
                                }`
                              ),
                            },
                            on: {
                              keypress: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.connectLinkedin.apply(
                                  null,
                                  arguments
                                )
                              },
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.connectLinkedin.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                            model: {
                              value: _vm.linkedinUsername,
                              callback: function ($$v) {
                                _vm.linkedinUsername = $$v
                              },
                              expression: "linkedinUsername",
                            },
                          }),
                          _c("vs-input", {
                            attrs: {
                              type: _vm.showPass ? "text" : "password",
                              label: _vm.$t("dash.bots.connection_password"),
                              placeholder: _vm.$t(
                                "dash.bots.connection_password"
                              ),
                            },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.connectLinkedin.apply(
                                  null,
                                  arguments
                                )
                              },
                              keypress: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.connectLinkedin.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                            model: {
                              value: _vm.linkedinPassword,
                              callback: function ($$v) {
                                _vm.linkedinPassword = $$v
                              },
                              expression: "linkedinPassword",
                            },
                          }),
                          _c("vs-button", {
                            staticClass: "btn-eye",
                            attrs: {
                              type: "fill",
                              icon: _vm.showPass
                                ? "visibility_off"
                                : "visibility",
                            },
                            on: {
                              click: function ($event) {
                                _vm.showPass = !_vm.showPass
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  ["linkedin", "instagram"].includes(_vm.page.network)
                    ? [
                        ["linkedin"].includes(_vm.page.network)
                          ? _c("p", { staticClass: "warning-two-auth" }, [
                              _vm._v(
                                _vm._s(_vm.$t("dash.bots.warning_two_auth"))
                              ),
                            ])
                          : _vm._e(),
                        _vm.page.network === "instagram" &&
                        _vm.instagramPagesUsernames
                          .map((e) => e.username)
                          .includes(_vm.linkedinUsername)
                          ? _c(
                              "div",
                              { staticClass: "username-conciergerie-diff" },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("dash.bots.username_used_insta") +
                                        _vm.instagramPagesUsernames.find(
                                          (e) =>
                                            e.username === _vm.linkedinUsername
                                        ).name
                                    )
                                  ),
                                ]),
                                _c(
                                  "vs-button",
                                  {
                                    staticClass:
                                      "vs-con-loading__container replace-username-btn",
                                    staticStyle: { "text-transform": "none" },
                                    attrs: {
                                      disabled:
                                        !_vm.linkedinUsername ||
                                        !_vm.linkedinPassword,
                                      id: "linkedin-direct-loading",
                                      color: "primary",
                                      type: "filled",
                                    },
                                    on: {
                                      click: () => (_vm.linkedinUsername = ""),
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("dash.button.cancel")))]
                                ),
                                _vm._v("\n          ou\n          "),
                                _c(
                                  "vs-button",
                                  {
                                    staticClass:
                                      "vs-con-loading__container replace-username-btn",
                                    attrs: {
                                      disabled:
                                        !_vm.linkedinUsername ||
                                        !_vm.linkedinPassword,
                                      id: "linkedin-direct-loading",
                                      color: "primary",
                                      type: "filled",
                                    },
                                    on: { click: _vm.connectLinkedin },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.bots.username_diff_insta_btn1"
                                        ) + _vm.linkedinUsername
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm.page &&
                            _vm.page.id !== "createPage" &&
                            _vm.page.network === "instagram" &&
                            _vm.linkedinUsername &&
                            _vm.page.name.trim() !== _vm.linkedinUsername.trim()
                          ? _c(
                              "div",
                              { staticClass: "username-conciergerie-diff" },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("dash.bots.username_diff_insta")
                                    )
                                  ),
                                ]),
                                _c(
                                  "vs-button",
                                  {
                                    staticClass:
                                      "vs-con-loading__container replace-username-btn",
                                    attrs: {
                                      disabled:
                                        !_vm.linkedinUsername ||
                                        !_vm.linkedinPassword,
                                      id: "linkedin-direct-loading",
                                      color: "primary",
                                      type: "filled",
                                    },
                                    on: { click: _vm.connectLinkedin },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.bots.username_diff_insta_btn1"
                                        ) + _vm.linkedinUsername
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v("\n          ou\n          "),
                                _c(
                                  "vs-button",
                                  {
                                    staticClass:
                                      "vs-con-loading__container replace-username-btn",
                                    staticStyle: { "text-transform": "none" },
                                    attrs: {
                                      disabled:
                                        !_vm.linkedinUsername ||
                                        !_vm.linkedinPassword,
                                      id: "linkedin-direct-loading",
                                      color: "primary",
                                      type: "filled",
                                    },
                                    on: {
                                      click: (e) =>
                                        _vm.connectLinkedin(e, true),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.bots.username_diff_insta_btn2"
                                        ) + _vm.page.name
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "vs-button",
                              {
                                staticClass: "vs-con-loading__container",
                                attrs: {
                                  id: "linkedin-direct-loading",
                                  color: "primary",
                                  type: "filled",
                                },
                                on: { click: _vm.connectLinkedin },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.bots.connect_direct"))
                                ),
                              ]
                            ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
          _c(
            "vs-popup",
            {
              staticClass: "two-factor-authentification",
              attrs: {
                title: "Authentification à deux facteurs",
                active: _vm.twoFactorPopup,
              },
              on: {
                "update:active": function ($event) {
                  _vm.twoFactorPopup = $event
                },
              },
            },
            [
              _c("TwoFactorAuthenticationPopup", {
                attrs: {
                  createPage: _vm.page.id === "createPage",
                  pageid: _vm.twoFactorPopup,
                  pages: _vm.pages,
                },
                on: {
                  closePopup: _vm.closePopup,
                  getPagesEvent: _vm.getPagesEvent,
                },
              }),
            ],
            1
          ),
          _vm.showLoader
            ? _c("component-loader", {
                attrs: {
                  progress: 90,
                  unlimitedProgress: true,
                  activeClose: true,
                },
                on: {
                  close: function ($event) {
                    _vm.showLoader = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }